<!--

@@author        j0Shi
@@date          2019.06.18
@@desc          Price/Vacancy template for the object page
@@usedby        ObjectVavancyForm > Object

-->
<template>
  <div
    class="object-vacancy-price"
    :class="{ disabled: isFetchingPrice }"
  >
    <!-- if no date has been selected yet, just show weekly min price -->
    <div
      v-if="showPrice"
      class="vacancy-details"
    >
      <object-price
        :price-min="priceMin"
        :data="data"
      />
    </div>

    <object-vacancy-buttons
      :data="data"
      :params="params"
      :has-vacancy-data="hasVacancyData"
      :data-ident="`OPEN_WIDGET_PICKR`"
      @click-pick-date="() => { $store.dispatch('OPEN_WIDGET_PICKR', true); }"
    />

    <p
      v-if="mandatoryCostCount > 0"
      class="mt-2 mb-0 text-small"
    >
      {{ $t('object:vacancy.price.mandatoryCostsInfo') }}.
    </p>
    <p
      v-if="completeTravelPrice > 0"
      class="mt-2 mb-0 text-small text-center"
    >
      <a
        v-smooth-scroll="{ duration: 200, updateHistory: false }"
        target="_self"
        href="#preise"
      >{{ $t('object:vacancy.price.mandatoryCostsLinkText') }}</a>
    </p>
  </div>
</template>

<script>
import ObjectPrice from 'components/ObjectPrice.vue';
import ObjectVacancyButtons from 'components/ObjectVacancyButtons.vue';
import Booking from 'mixins/Booking';

export default {
  name: 'ObjectVacancyPrice',
  components: {
    ObjectPrice,
    ObjectVacancyButtons,
  },
  mixins: [
    Booking,
  ],
  props: {
    // min price from the object
    priceMin: {
      type: Number,
      default: 0,
    },
    // marker for existing vacancy data, used to conditionaly display info
    hasVacancyData: {
      type: Boolean,
      default: false,
    },
    // query parameter from vacancy form, used for booking and request routes
    params: {
      type: Object,
      required: true,
    },
    // data from price request
    data: {
      type: Object,
      default() {
        return {
          priceObject: {
            currency: 'EUR',
            original: null,
            price: null,
            priceComplete: null,
            startDate: null,
            endDate: null,
            duration: null,
          },
        };
      },
    },
  },
  computed: {
    priceData() {
      return this.data;
    },
    // @vuese
    // calucluates the sum of mandatory costs to conditionally display
    // a link to the costs component
    mandatoryCostSum() {
      if (Object.keys(this.mandatoryCosts).length) {
        return Object.keys(this.mandatoryCosts)
          .map((key) => this.mandatoryCosts[key].price)
          .reduce((sum, num) => sum + num);
      }
      return 0;
    },
    // @vuese
    // calucluates the count of mandatory costs to conditionally display
    // a link to the costs component
    mandatoryCostCount() {
      return Object.keys(this.mandatoryCosts).length;
    },
    isFetchingPrice() {
      return this.$store.getters.getIsFetchingPrice;
    },
    showPrice() {
      return ((this.priceMin > 0 && this.priceMin < 999999) || (this.data.priceObject?.price > 0));
    },
  },
};
</script>

<style lang="scss" scoped>
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
</style>
